import { CATEGORY_FILTERS_OPTIONS } from '@scalefast/core';
/**
 * Adapters should not be used in the store.
 * https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/600
 *
 * @deprecated
 */
export class SearchResultsPageQueryParamsAdapter {
  static projectFiltersToQueryParams(filters) {
    const sortQueryParams = {};
    sortQueryParams.page = filters.offset;
    sortQueryParams.pageSize = filters.pageSize;
    if (!filters.filters.length) {
      return sortQueryParams;
    }
    const filterQueryParams = transformFiltersToQueryParams(filters.filters);
    return {
      ...sortQueryParams,
      ...filterQueryParams
    };
  }
  static buildFiltersFromQueryParams(queryParams) {
    return {
      offset: getPageFromQueryParams(queryParams),
      pageSize: getPageSizeFromQueryParams(queryParams),
      filters: getFiltersFromQueryParams(queryParams)
    };
  }
  static transformFilterToQueryString(filters) {
    const {
      offset,
      pageSize,
      filters: filterList
    } = filters;
    const offsetString = `offset=${offset}&`;
    const pageSizeString = `pageSize=${pageSize}`;
    const filterString = filterList.map(transformFilter).join('&');
    return `${offsetString}${pageSizeString}${filterString}`;
  }
}
function transformFilter(filter) {
  const {
    groupBy,
    name,
    values
  } = filter;
  if (groupBy === 'sort') {
    return `&${groupBy}=${values.join(',')}`;
  }
  if (name === 'search') {
    return `&query=${values}`;
  }
  if (groupBy === 'crit' && name === '()') {
    return `&${groupBy}=${name}`;
  }
  return `&${groupBy}=${name}:${values.join(',')}`;
}
function transformFiltersToQueryParams(filter) {
  const filterParams = {};
  filter.map(item => {
    if (item.values.length > 0) {
      filterParams[item.name] = item.values.map(option => {
        return option;
      }).join();
    }
  });
  return filterParams;
}
function getPageFromQueryParams(queryParams) {
  const offset = Number(queryParams.get('offset'));
  if (!offset || offset <= 0) {
    return CATEGORY_FILTERS_OPTIONS.DEFAULT_PAGE_OFFSET;
  }
  return offset;
}
function getPageSizeFromQueryParams(queryParams) {
  const pageSize = Number(queryParams.get('pageSize'));
  if (!pageSize || pageSize <= 0) {
    return CATEGORY_FILTERS_OPTIONS.DEFAULT_PAGE_SIZE;
  }
  return pageSize;
}
function getFiltersFromQueryParams(queryParams) {
  const filters = [];
  queryParams.keys.filter(key => key !== 'offset' && key !== 'pageSize').forEach(key => {
    const values = queryParams.getAll(key);
    if (key === 'query') {
      filters.push({
        name: 'search',
        values: values,
        groupBy: ''
      });
      return;
    }
    if (key !== 'sort') {
      const valuesSplited = values[0].split(':');
      if (!valuesSplited[1]) {
        filters.push({
          groupBy: key,
          values: [],
          name: valuesSplited[0]
        });
        return;
      }
      filters.push({
        groupBy: key,
        values: valuesSplited[1].split(','),
        name: valuesSplited[0]
      });
      return;
    }
    filters.push({
      name: key,
      values: values,
      groupBy: key
    });
  });
  return filters;
}
